import { combineReducers } from '@reduxjs/toolkit'

import substitutePortalReducer from './substitute-portal'

const combinedReducer = combineReducers({
  substitute: substitutePortalReducer,
})

export default combinedReducer
